import useEventEmitter from '@/_core/hooks/useEventEmitter'
import useApiRequest from '@/_core/hooks/useApiRequest'
import { activateDemo } from '@/services/demo'
import store from '@/store'

export default function DemoController () {
  const { $on, $off, $emit } = useEventEmitter()

  // Activate demo subscription
  const activateRequest = useApiRequest(activateDemo)
  activateRequest.$on('success', () => {
    $emit('requestActivateDemo-success', activateRequest.data)
  })
  activateRequest.$on('error', () => {
    $emit('requestActivateDemo-error', activateRequest.errors)
  })
  const requestActivate = async () => {
    await activateRequest.request()
  }

  $on('requestActivateDemo-success', () => {
    store.user.requestDemo()
  })

  return {
    requestActivate,
    $on,
    $off
  }
}
